import { COLORS } from "../../../styles/uiConstants";

/**
 * Tüm liste tablolarında ORTAK başlık hücresi stili.
 *
 * NOT: `textTransform: "uppercase"` BİLEREK YOK — Türkçe casing'i bozar
 * (İ → noktasız I). Başlık etiketleri literal büyük harf yazılır.
 */
export const listHeadCellSx = {
  fontWeight: 600,
  fontSize: "0.75rem",
  letterSpacing: "0.02em",
  color: COLORS.slate500,
  bgcolor: COLORS.slate50,
  borderBottom: `1px solid ${COLORS.slate200}`,
  py: 1.25,
  whiteSpace: "nowrap",
};
